import { Input, type InputProps } from '@billy/design-system'
import { type ChangeEvent, type ReactElement } from 'react'

import { useFormContext } from '../../../../../../../../hooks'
import type { PaymentMethodsFormSchema } from '../../../../types/paymentMethods/paymentMethodsFormSchema'
import type { PaymentMethodsSettings } from '../../../../types/paymentMethods/paymentMethodsSettings'

export interface PaymentMethodsTextFieldProps {
  fieldKey: keyof PaymentMethodsSettings
  label?: string
  onValueChange?: () => void
  placeholder?: string
  size?: InputProps['size']
}

export const PaymentMethodsTextField = ({
  fieldKey,
  label,
  onValueChange,
  placeholder,
  size,
}: PaymentMethodsTextFieldProps): ReactElement => {
  const { FormItem } = useFormContext<PaymentMethodsFormSchema>()

  return (
    <FormItem
      label={label}
      name={fieldKey}
      render={({ field: { onChange, ...rest } }) => {
        const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
          onChange(event)
          onValueChange?.()
        }

        return <Input {...rest} onChange={handleInputChange} placeholder={placeholder} size={size} />
      }}
    />
  )
}
